<script lang="ts">
    import type {UIcons, UIconVariant} from './types';

    export let icon: UIcons;
    export let color = 'inherit';
    export let label: string | null = null;
    export let lineHeight = 'inherit';
    export let variant: UIconVariant = 'bold';
    export let additionalClasses = '';

    const variantToClassPart = {
        'bold': 'br',
        'solid': 'sr'
    };
</script>

{#if label}
    <span class="uicon fi-{variantToClassPart[variant]}-{icon} {additionalClasses}"
          style:--color={color}
          style:--lineHeight={lineHeight}
          aria-label={label}
          title={label}>
    </span>
{:else}
    <span class="uicon fi-{variantToClassPart[variant]}-{icon} {additionalClasses}"
          style:--color={color}
          style:--lineHeight={lineHeight}
          aria-hidden="true">
    </span>
{/if}

<style lang="less">
    .uicon {
        line-height: var(--lineHeight);
        color: var(--color);
        display: inline-flex;
        align-items: center;

        &:before {
            display: inline-flex;
            align-items: center;
            line-height: var(--lineHeight);
        }
    }
</style>